<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Track Order</p>
          </div>
        </div>

        <div class="level-right">
          <div v-if="this.shippingData.length > 1" class="level-item">
            <select class="select" name="ShippingReferenceID" v-model="ShippingReferenceID" required
              @change="getOrderHistory">
              <option v-for="(value,index) in shippingData" :key="index" :value="value">
                {{ value}}</option>
            </select>
          </div>
          <div class="level-item">
            <router-link :to="{ name: 'KitOrderHistory', params: { kitType } }"
              class="button is-small is-link">Back to List</router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="section is-main-section">
      <div>
        <p class="title is-6">Order No : {{ orderID }}</p>
      </div>
      <br />
      <card-component class="has-table">
        <b-table :loading="isLoading" :paginated="paginated" :per-page="10" :striped="true"
          :hoverable="true" default-sort="orderTime" default-sort-direction="DESC"
          :data="orderhistoryData" style="overflow-x:scroll">
          <template slot-scope="props">
            <b-table-column label="Time Stamp" field="timestamp" centered>
              {{ props.row.timestamp }}
            </b-table-column>

            <b-table-column label="Source City" field="sourcecity" centered>
              {{ props.row.sourcecity }}
            </b-table-column>

            <b-table-column label="Source State" field="sourcestate" centered>
              {{ props.row.sourcestate }}
            </b-table-column>
            <b-table-column label="Shipping Code" field="shippincode" centered>
              {{ props.row.shippincode }}
            </b-table-column>
            <b-table-column label="Ship City" field="shipcity" centered>
              {{ props.row.shipcity }}
            </b-table-column>
            <b-table-column label="Ship State" field="shipstate" centered>
              {{ props.row.shipstate }}
            </b-table-column>

            <b-table-column label="Process" field="process" centered>
              {{ props.row.process || '' }}
            </b-table-column>
            <b-table-column label="Consignment Status" field="consignmentstatus" centered>
              <span class="tag is-primary sizeadjust">
                {{ props.row.consignmentstatus }}
              </span>
            </b-table-column>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-dark has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>No Tracking Record Found&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import helper from '@/utils/helper'
import moment from 'moment'

export default {
  name: 'orderHistoryKitType',
  components: {
    CardComponent
  },
  props: ['kitType', 'orderID', 'ShippingReferenceNo'],
  data () {
    return {
      data: [],
      total: 0,
      shippingData: [],
      ShippingReferenceID: '',
      current: 1,
      rangeBefore: 3,
      rangeAfter: 1,
      order: 'is-right',
      size: '',
      isSimple: false,
      isRounded: false,
      prevIcon: 'chevron-left',
      nextIcon: 'chevron-right',
      isModalActive: false,
      trashObject: null,
      isLoading: false,
      paginated: false,

      totalstudents: '',
      checkedRows: [],
      orderhistoryData: [],

      loadingComponent: null,
      kit: {}
    }
  },
  async created () {
    console.log(this.ShippingReferenceNo)
    if (this.ShippingReferenceNo !== '') {
      this.shippingData = this.ShippingReferenceNo.split(',')
      console.log(this.shippingData)
      this.ShippingReferenceID = this.shippingData[0]
      console.log(this.ShippingReferenceID)
    } else {
      this.ShippingReferenceID = ''
    }

    await this.getOrderHistory()
  },

  methods: {
    getTag (status) {
      return helper.getClass(status)
    },
    getOrderHistory: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        // let assignOb = {
        //   ShippingReferenceNo: this.ShippingReferenceNo
        // }
        console.log('this.ShippingReferenceID', this.ShippingReferenceID)
        const response = await http.get(`${constants.API_URL}/api/order/shipping/details/${this.ShippingReferenceID}`)

        this.loadingComponent.close()
        if (response) {
          this.orderhistoryData = response.data
          this.orderhistoryData.forEach(obj => {
            obj.timestamp = moment(obj.timestamp).format('DD-MM-YYYY h:mm A')
          })
        } else {
          this.orderhistoryData = ''
        }
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order history', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
<style scoped>
.sizeadjust {
  font-size: 14px;
}
</style>
